import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  label: {
    color: theme.colors.light_text,
    display: 'inline',
    '&.Mui-disabled': {
      color: theme.colorPalette.white_30,
      opacity: 0.6
    }
  },
  container: {
    minHeight: 39,
    cursor: 'pointer',
    marginBottom: 0
  },
  'light-label': {
    color: theme.colors.text_secondary,
    display: 'inline'
  },
  'light-checkboxColorPrimary': {
    color: theme.colors.text_secondary
  },
  'dark-label': {
    color: `${theme.colors.light_text} !important`,
    '&.Mui-disabled': {
      color: theme.colorPalette.white_30,
      opacity: 0.6
    }
  },
  'dark-checkboxRoot': {
    height: 'auto'
  },
  lightCheckboxLongLabel: {
    height: 'auto',
    alignSelf: 'baseline',
    color: theme.colors.text_secondary
  },
  darkCheckboxLongLabel: {
    height: 'auto',
    alignSelf: 'baseline',
    color: theme.colors.text_primary
  },
  error: {
    color: `${theme.colorPalette.red_10} !important`
  },
  checkboxLongLabelError: {
    height: 'auto',
    alignSelf: 'baseline',
    paddingTop: theme.spacing(2),
    color: `${theme.colorPalette.red_10} !important`
  },
  helperText: {
    display: 'none'
  }, // For overriding
  customControlLabel: {
    alignSelf: 'flex-start',
    flex: 'auto'
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  subLabel: {
    marginTop: theme.spacing(0.5),
    color: theme.colorPalette.green_75,
    fontSize: 12,
    fontWeight: 400
  },
  description: {
    color: theme.colorPalette.green_75,
    marginTop: theme.spacing(1)
  }
});

export default makeStyles(styles);
